/* globals googleyolo */

import firebase from "./firebase";
import Config from "../config";

class GoogleYoloManager {
  constructor(props) {
    this.googleYoloReady = false;
    this.awaitingSignIn = false;
    this.signInConfig = {
      supportedAuthMethods: [
        "https://accounts.google.com",
        "googleyolo://id-and-password"
      ],
      supportedIdTokenProviders: [
        {
          uri: "https://accounts.google.com",
          clientId: Config.googleClientId
        }
      ]
    };
  }

  addOnLoadListener() {
    if (typeof window !== `undefined`) {
      window.onGoogleYoloLoad = () => {
        this.googleYoloReady = true;
        if (this.awaitingSignIn) {
          this.awaitingSignIn = false;
          this.login();
        }
      };
    }
  }

  async login() {
    if (!this.googleYoloReady) {
      this.awaitingSignIn = true;
      return false;
    }
    try {
      const credential = await googleyolo.retrieve(this.signInConfig);
      this.signInWithCredential(credential);
      return true;
    } catch (error) {
      // console.log(error);
      if (error.type === "noCredentialsAvailable") {
        try {
          const credential = await googleyolo.hint(this.signInConfig);
          this.signInWithCredential(credential);
          return true;
        } catch (error2) {
          return false;
          // Fallback to manual sign in only
        }
      } else {
        return false;
      }
    }
  }

  logout() {
    if (!this.googleYoloReady) {
      return false;
    }
    return googleyolo.disableAutoSignIn();
  }

  signInWithCredential = credential => {
    const { idToken } = credential;
    const authCredential = firebase.auth.GoogleAuthProvider.credential(idToken);
    firebase.auth().signInWithCredential(authCredential);
  };
}

const googleYoloManager = new GoogleYoloManager();
export default googleYoloManager;



// WEBPACK FOOTER //
// ./src/lib/googleYoloManager.js